import { FC, createContext, useContext, useState } from 'react';

export type InsightsBoundaryState = {
  startDate: Date | null;
  endDate: Date | null;
  setStartDate: (startDate: Date | null) => void;
  setEndDate: (startDate: Date | null) => void;
};

export const defaultState = {
  startDate: null,
  endDate: null,
  setStartDate: () => null,
  setEndDate: () => null,
};

export const InsightsBoundaryContext = createContext<InsightsBoundaryState>(defaultState);

export const useInsightsBoundaryContext = () => useContext(InsightsBoundaryContext);

export const InsightsBoundaryContextProvider: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);

  const context: InsightsBoundaryState = {
    startDate,
    endDate,
    setStartDate,
    setEndDate,
  };

  return (
    <InsightsBoundaryContext.Provider value={context}>{children}</InsightsBoundaryContext.Provider>
  );
};
